import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

const ADMIN_TOKEN_KEY = "sfs_admin_token";

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

api.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (!token || !config.url) return config;
  const url = config.url;
  const method = (config.method || "").toLowerCase();
  const needsAuth =
    url.includes("/admin") ||
    url.startsWith("/content") ||
    url.startsWith("/eligibility") ||
    (url.startsWith("/inquiries") && method !== "post") ||
    (url.startsWith("/news") && method !== "get");
  if (needsAuth) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
